import { useEffect, useState } from "react";
import ReturnPolicyTable from "./ReturnPolicyTable";
import EditReturnPolicyModal from "./EditReturnPolicyModal";
import { useSelector } from "react-redux";
import { RootState } from "slices/app/store/store";
import { getPolicy, updatePolicy } from "./services/returnPolicy.service";
import notistack from "modules/core/notistack";
import { HasPermission } from "Layout/Permissions/permissionsCache";

type LocalPolicyType = {
  returnDays: number;
  exchangeDays: number;
  buybackAfter: number;
};

const ReturnPolicySection = () => {
  const [showModal, setShowModal] = useState(false);
  const [policyData, setPolicyData] = useState<LocalPolicyType>({
    returnDays: 0,
    exchangeDays: 0,
    buybackAfter: 0,
  });
  const [canEdit, setCanEdit] = useState(false);

  useEffect(() => {
    loadPolicy();
  }, []);

  const loadPolicy = async () => {
    try {
      const res = await getPolicy();
      const mappedPolicy: LocalPolicyType = {
        returnDays: res.returnDays,
        exchangeDays: res.exchangeDays,
        buybackAfter: res.buyBackDays,
      };
      setPolicyData(mappedPolicy);
    } catch (error) {
      console.error("❌ Failed to load policy", error);
    }
  };


  const user = useSelector((state: RootState) => state.Login?.user);
  useEffect(() => {
    const edit = localStorage.mayavePurityEdit
    const mayavePurityEdit = edit;
    const roleName = user?.roleName;

    if (mayavePurityEdit === "true" && roleName === "Super Admin") {
      setCanEdit(true);
    }
  }, [user]);


  const handleEditClick = () => setShowModal(true);

  const handleCloseModal = () => setShowModal(false);

  const handleSave = async (updatedPolicy: LocalPolicyType) => {
    try {
      const payload = {
        returnDays: updatedPolicy.returnDays,
        exchangeDay: updatedPolicy.exchangeDays,
        buyBackDays: updatedPolicy.buybackAfter,
      };
      const res = await updatePolicy(payload);
      if (res.status == 200) {
        notistack.notifyFromApi(res);
        setPolicyData(updatedPolicy);
        setShowModal(false);
      } else {
        notistack.notifyFromApi(res)
      }
    } catch (error: any) {
      notistack.error(error.message)
    }
  };

  return (
    <>
      <div className="page-content">
        {HasPermission('StorePolicy.Read') &&
          <ReturnPolicyTable
            policyData={policyData}
            onEdit={handleEditClick}
            canEdit={canEdit}
          />
        }

        <EditReturnPolicyModal
          show={showModal}
          handleClose={handleCloseModal}
          policyData={policyData}
          onSave={handleSave}
        />
      </div>
    </>
  );
};

export default ReturnPolicySection;
